"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BypassAuthentication = void 0;
const tslib_1 = require("tslib");
const client_utils_1 = require("@sensenet/client-utils");
const ConstantContent_1 = require("../Repository/ConstantContent");
const LoginState_1 = require("./LoginState");
/**
 * Default authentication service that bypasses the authentication process
 */
class BypassAuthentication {
    constructor() {
        /**
         * The current state of the authentication
         */
        this.state = new client_utils_1.ObservableValue(LoginState_1.LoginState.Unknown);
        /**
         * Current user observable property - Will publish the Visitor user for BypassAuthentication
         */
        this.currentUser = new client_utils_1.ObservableValue(ConstantContent_1.ConstantContent.VISITOR_USER);
    }
    /**
     * Checks for update if neccessary. For BypassAuthentication always resolves immedietly with false
     */
    checkForUpdate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    /**
     * Login method - not available for BypassAuthentication
     */
    login() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('Not allowed when authentication is bypassed.');
        });
    }
    /**
     * logout method - not available for BypassAuthentication
     */
    logout() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('Not allowed when authentication is bypassed.');
        });
    }
    /**
     * Disposes the service
     */
    dispose() {
        /** */
    }
}
exports.BypassAuthentication = BypassAuthentication;
//# sourceMappingURL=BypassAuthentication.js.map